import Image from 'next/legacy/image';
import { FC } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { Button } from 'src/general/components/Button/Button';
import carmaGenericImageLoader from 'src/general/helpers/carmaGenericImageLoader';
import {
  ConfirmationFormValues,
  PersonalizedQuoteFormProps,
} from 'src/personalised-quote/templates/Forms/PersonalizedQuoteForm.type';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';

interface ConfimationPageProps extends PersonalizedQuoteFormProps<ConfirmationFormValues> {}

export const Confirmation: FC<ConfimationPageProps> = () => {
  const content = MICROCOPY.PERSONALIZED_QUOTE_CONFIRMATION_DESCRIPTION;

  return (
    <section className={styles.confirmation}>
      <div className={styles.imageContainer}>
        <Image
          src="/images/components/PersonalizedQuoteStep9ConfirmationPage/Computer.svg"
          width={160}
          height={160}
          alt=""
          loader={carmaGenericImageLoader}
        />
      </div>
      <div className={styles.contentContainer} data-testid="PERSONALIZED_QUOTE_CONFIRMATION_TITLE">
        {getMicrocopy(content, true)}
      </div>
      <div className={styles.buttonContainer}>
        <Button variant="primary" fullWidth href="/account/finance-quotes" data-testid="submit">
          {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_CONFIRMATION_BUTTON_LABEL)}
        </Button>
      </div>
    </section>
  );
};
